import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchSearchSuggestions = async (query) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-search-suggestions`,
      { query },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching search suggestions:', error.message);
    throw new Error(
      'Wystąpił błąd podczas wyszukiwania. Spróbuj ponownie później.'
    );
  }
};

export const fetchSearchDetails = async ({ url, title, description }) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-search-details`,
      { url, title, description },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching search details:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania streszczenia. Spróbuj ponownie później.'
    );
  }
}; 